import axios from 'axios';
import { get } from 'lodash';
import CONFIG from '@/config';
import { getRestHeaders } from '@/common/utils/api';

export async function navigateToPlan(
  customer_id,
  questionnaire_slug,
  session,
  enqueueSnackbar?
) {
  const res = await axios.post(
    CONFIG.FORMS_API_URL + '/staff/customer-link/',
    /* eslint-disable */
    JSON.stringify({
      customer_id: customer_id,
      questionnaire_slug: `${questionnaire_slug}`,
      action: 'customer-plan',
      session: session
    }),
    /* eslint-disable */
    {
      headers: {
        'Content-Type': 'application/json',
        ...getRestHeaders(undefined, 'Bearer')
      }
    }
  );
  const staffLink = get(res, 'data.data.link');
  if (!staffLink) {
    if (enqueueSnackbar) {
      enqueueSnackbar(
        'A problem was encountered fetching customer link from the booking API.',
        { variant: 'error' }
      );
    }
  } else {
    window.open(staffLink, '_blank');
  }
}
